import {styled, Typography} from '@mui/material'
import theme from '../../../themes'

export const StyledTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'sender'
})(({sender}) => ({
  margin: 0,
  fontSize: theme.typography.heading.fontSize.xs,
  paddingLeft: sender === 'bot' ? '10px' : 0,
  '& p': {
    margin: 0,
    height: 'auto',
    alignItems: 'center'
  },
  '& code': {
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    backgroundColor: 'none',
    fontSize: theme.typography.heading.fontSize.xs,
    fontFamily: theme.typography.h1.fontFamily
  },
  '& a': {
    color: 'white',
    textDecoration: 'none',
    fontSize: theme.typography.heading.fontSize.xs,
    fontFamily: theme.typography.h1.fontFamily
  }
}))
